var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgConciergeinline = function SvgConciergeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "concierge_inline_svg__Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 50 50"
    },
    viewBox: "3 0 50 50"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".concierge_inline_svg__st1{fill:#00a98f}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5248_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5256_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5269_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5270_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5271_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "concierge_inline_svg__XMLID_5272_",
    d: "M30 15.3v-2.9c0-.9-.7-1.5-1.5-1.5h-7c-.8 0-1.5.7-1.5 1.5v3.1c-.2.5-.2 1-.2 1.5 0 2.9 2.3 5.2 5.2 5.2s5.2-2.4 5.2-5.2c0-.6-.1-1.1-.2-1.7zm-5 5c-1.8 0-3.3-1.5-3.3-3.3 0-.5.1-1 .4-1.5H28c.2.4.4 1 .4 1.5-.1 1.9-1.6 3.3-3.4 3.3z",
    className: "concierge_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5273_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5274_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5275_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5276_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "concierge_inline_svg__XMLID_5277_",
    d: "M27 28.1c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4c.3 0 .4.2.4.4z",
    className: "concierge_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5279_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5280_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5281_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "concierge_inline_svg__XMLID_5282_",
    d: "M27 29.9c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4c.3 0 .4.2.4.4z",
    className: "concierge_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5284_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5285_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5286_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "concierge_inline_svg__XMLID_5287_",
    d: "M27 31.7c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4c.3 0 .4.2.4.4z",
    className: "concierge_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5289_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5290_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5291_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "concierge_inline_svg__XMLID_5292_",
    d: "M27 33.5c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4c.3 0 .4.2.4.4z",
    className: "concierge_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5294_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5295_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5296_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5297_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "concierge_inline_svg__XMLID_5298_",
    cx: 26.7,
    cy: 35.3,
    r: 0.4,
    className: "concierge_inline_svg__st1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5299_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5300_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5301_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "concierge_inline_svg__XMLID_5302_",
    d: "M23.7 28.1c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4z",
    className: "concierge_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5304_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5305_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5306_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5307_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "concierge_inline_svg__XMLID_5308_",
    cx: 23.3,
    cy: 29.9,
    r: 0.4,
    className: "concierge_inline_svg__st1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5309_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5310_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5311_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5312_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "concierge_inline_svg__XMLID_5313_",
    cx: 23.3,
    cy: 31.7,
    r: 0.4,
    className: "concierge_inline_svg__st1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5314_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5315_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5316_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5317_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "concierge_inline_svg__XMLID_5318_",
    cx: 23.3,
    cy: 33.5,
    r: 0.4,
    className: "concierge_inline_svg__st1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5319_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5320_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5321_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5322_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "concierge_inline_svg__XMLID_5323_",
    cx: 23.3,
    cy: 35.3,
    r: 0.4,
    className: "concierge_inline_svg__st1"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5324_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5325_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge_inline_svg__XMLID_5326_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "concierge_inline_svg__XMLID_5327_",
    d: "M34.5 32.9v6h-1.9v-6c0-4-3.2-7.3-7.1-7.6v12.4h-1V25.3c-4 .2-7.1 3.6-7.1 7.6v6h-1.9v-6c0-5.3 4.3-9.5 9.5-9.5s9.5 4.2 9.5 9.5z",
    className: "concierge_inline_svg__st1"
  }))))))));
};
export default SvgConciergeinline;